module.exports = __webpack_public_path__ + "static/img/victim-kids-7.2d4820d2.png";